import React, { useState, useEffect, useContext } from "react";
import { TextField, Paper } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button/Button";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DoneIcon from "@mui/icons-material/Done";
import { Divider } from "@mui/material";
import FormDialog from "../modal/modal";
import { SchoolContex } from "../../Helper/Contex";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Helmet } from "react-helmet";

import axios from "axios";
import Swal from "sweetalert2";

const Register = () => {
  const { courses } = useContext(SchoolContex);

  const [age, setAge] = React.useState("");

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    applied_course: "",
    state: "",
    city: "",
  });

  const [idproofimage, setIdproofimage] = useState();
  const [adproofimage, setAdproofimage] = useState();
  const [admitimage, setAdmitimage] = useState();
  const [tenmarksimage, setTenmarksimage] = useState();
  const [twelvemarksimage, setTwelvemarksimage] = useState();

  const handleFormData = (e) => {
    // console.log("rrr");
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAdproofimage = (e) => {
    setAdproofimage(e.target.files[0]);
  };
  const handleadmitimage = (e) => {
    setAdmitimage(e.target.files[0]);
  };
  const handletenmarksimage = (e) => {
    setTenmarksimage(e.target.files[0]);
  };
  const handletwelvemarksimage = (e) => {
    setTwelvemarksimage(e.target.files[0]);
  };
  const handleIdproofimage = (e) => {
    setIdproofimage(e.target.files[0]);
  };

  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const [load, setLoad] = useState(false);

  const hadleSubmit = () => {
    // console.log(formData, adproofimage, admitimage, tenmarksimage, twelvemarksimage);
    const postData = new FormData();
    postData.append("name", formData.name);
    postData.append("email", formData.email);
    postData.append("phone", formData.phone);
    postData.append("applied_course", formData.applied_course);
    postData.append("state", formData.state);
    postData.append("city", formData.city);

    postData.append("idproofimage", idproofimage);
    postData.append("adproofimage", adproofimage);
    postData.append("admitimage", admitimage);
    postData.append("tenmarksimage", tenmarksimage);
    postData.append("twelvemarksimage", twelvemarksimage);

    setLoad(true);
    axios
      .post(`${process.env.REACT_APP_MAIN_API}saveRegistration`, postData)
      .then((res) => {
        // console.log("ress", res);
        setLoad(false);

        // toast("Wow so easy !")

        if (res.data.status === 200) {
          handleClose();
          Swal.fire({
            title: "Success!",
            text: "Your Registration Successfull !",
            icon: "success",
            confirmButtonText: "Ok",
          });
        } else {
          toast.error(
            "Something went Wrong, Please check your Document Size and extentions",
            {
              // toast.error(res.data.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            }
          );
        }
      })
      .catch((err) => {
        setLoad(false);
        // console.log(err.response);
        toast.error(err.response.data.message, {
          // toast.error(res.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      });
  };

  const FileUpload = () => {
    return (
      <>
        <div className="bg-light">
          <Paper>
            <div className="row p-4 small">
              <ToastContainer />

              <div className="p-3 pb-5 text-danger">
                <div>
                  <b> Document Format should be - .jpeg .jpg .png </b>
                </div>
                <div>
                  <b> Maximum image file size -1MB or 1024 KB </b>
                </div>
              </div>

              <div className="col-md-12 p-3">
                <div className="row">
                  <div className="col-2 text-center">
                    <input
                      accept="image/*"
                      style={{ display: "none" }}
                      id="raised-button-file0"
                      multiple
                      type="file"
                      // value={adproofimage}
                      onChange={handleIdproofimage}
                    />
                    <label htmlFor="raised-button-file0">
                      <Button variant="outlined" component="span">
                        <UploadFileIcon /> Upload
                      </Button>
                    </label>
                  </div>
                  <div className="col-md-5">
                    <span> Adhaar Card/PAN Card </span>
                  </div>

                  <div className="col-md-5">
                    {idproofimage ? (
                      <span className="text-success">
                        <DoneIcon />
                      </span>
                    ) : (
                      <span className="text-danger">Not Uploaded</span>
                    )}
                  </div>
                </div>
              </div>
              <Divider />

              <div className="col-md-12 p-3">
                <div className="row">
                  <div className="col-2 text-center">
                    <input
                      accept="image/*"
                      style={{ display: "none" }}
                      id="raised-button-file1"
                      multiple
                      type="file"
                      // value={adproofimage}
                      onChange={handleAdproofimage}
                    />
                    <label htmlFor="raised-button-file1">
                      <Button variant="outlined" component="span">
                        <UploadFileIcon /> Upload
                      </Button>
                    </label>
                  </div>
                  <div className="col-md-5">
                    <span> Final Year Marksheet/Pass Certificate </span>
                  </div>

                  <div className="col-md-5">
                    {adproofimage ? (
                      <span className="text-success">
                        <DoneIcon />
                      </span>
                    ) : (
                      <span className="text-danger">Not Uploaded</span>
                    )}
                  </div>
                </div>
              </div>
              <Divider />

              <div className="col-md-12 p-3">
                <div className="row">
                  <div className="col-2 text-center">
                    <input
                      accept="image/*"
                      style={{ display: "none" }}
                      id="raised-button-file2"
                      multiple
                      type="file"
                      // value={admitimage}
                      onChange={handleadmitimage}
                    />
                    <label htmlFor="raised-button-file2">
                      <Button variant="outlined" component="span">
                        <UploadFileIcon /> Upload
                      </Button>
                    </label>
                  </div>
                  <div className="col-md-5">
                    <span> Class 10 Admit Card </span>
                  </div>
                  <div className="col-md-5">
                    {admitimage ? (
                      <span className="text-success">
                        <DoneIcon />
                      </span>
                    ) : (
                      <span className="text-danger">Not Uploaded</span>
                    )}
                  </div>
                </div>
              </div>
              <Divider />

              <div className="col-md-12 p-3">
                <div className="row">
                  <div className="col-2 text-center">
                    <input
                      accept="image/*"
                      style={{ display: "none" }}
                      id="raised-button-file3"
                      multiple
                      type="file"
                      // value={tenmarksimage}
                      onChange={handletenmarksimage}
                    />
                    <label htmlFor="raised-button-file3">
                      <Button variant="outlined" component="span">
                        <UploadFileIcon /> Upload
                      </Button>
                    </label>
                  </div>
                  <div className="col-md-5">
                    <span> Class 10 Marksheet </span>
                  </div>
                  <div className="col-md-5">
                    {tenmarksimage ? (
                      <span className="text-success">
                        <DoneIcon />
                      </span>
                    ) : (
                      <span className="text-danger">Not Uploaded</span>
                    )}
                  </div>
                </div>
              </div>
              <Divider />
              <div className="col-md-12 p-3">
                <div className="row">
                  <div className="col-2 text-center">
                    <input
                      accept="image/*"
                      style={{ display: "none" }}
                      id="raised-button-file4"
                      multiple
                      type="file"
                      // value={twelvemarksimage}
                      onChange={handletwelvemarksimage}
                    />
                    <label htmlFor="raised-button-file4">
                      <Button variant="outlined" component="span">
                        <UploadFileIcon /> Upload
                      </Button>
                    </label>
                  </div>
                  <div className="col-md-5">
                    <span> Class 12 Marksheet </span>
                  </div>
                  <div className="col-md-5">
                    {twelvemarksimage ? (
                      <span className="text-success">
                        <DoneIcon />
                      </span>
                    ) : (
                      <span className="text-danger">Not Uploaded</span>
                    )}
                  </div>
                </div>
              </div>
              <Divider />

              <div className="col-md-12 p-5 text-center">
                <Button
                  variant="contained"
                  onClick={hadleSubmit}
                  disabled={load ? true : false}
                >
                  {" "}
                  Submit{" "}
                </Button>
              </div>
            </div>
          </Paper>
        </div>
      </>
    );
  };

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Register</title>
        {/* <meta name="description" content="" /> */}
      </Helmet>

      <ToastContainer />

      <div className="">
        <div className="p-0 m-0">
          <div className="col-12 register infobox">
            <img
              src="assets/banner/register.jpg"
              className="bg-over col-12"
              alt="pews register banner"
            />

            <div className="row mx-0 align-items-center">
              <div className="col-md-7">
                <div className="d-flex justify-content-center reg-back">
                  <div>
                    <h2 className="text-white full-opacity">
                      Accessible Quality Education{" "}
                    </h2>
                  </div>
                </div>
                <div className="d-flex justify-content-center reg-back">
                  <div>
                    <h2 className=" full-opacity">
                      Enroll Now for the session 2024-25{" "}
                    </h2>
                  </div>
                </div>
              </div>

              <div className="col-md-5 p-3 py-5">
                <div className="p-3 bg-light">
                  <Paper>
                    <div className="row p-4">
                      <div className="col-md-12 p-3">
                        <TextField
                          label="Your Full Name"
                          variant="standard"
                          name="name"
                          value={formData.name}
                          onChange={handleFormData}
                          className="col-md-12"
                        />
                      </div>
                      <div className="col-md-12 p-3">
                        <TextField
                          label="Email Id"
                          variant="standard"
                          name="email"
                          value={formData.email}
                          onChange={handleFormData}
                          className="col-md-12"
                        />
                      </div>

                      <div className="col-md-6 p-3">
                        <TextField
                          label="Contact no."
                          variant="standard"
                          name="phone"
                          value={formData.phone}
                          onChange={handleFormData}
                          className="col-md-12"
                        />
                      </div>
                      <div className="col-md-6 p-3">
                        <TextField
                          label="State"
                          variant="standard"
                          name="state"
                          value={formData.state}
                          onChange={handleFormData}
                          className="col-md-12"
                        />
                      </div>
                      <div className="col-md-6 p-3">
                        <TextField
                          label="City"
                          variant="standard"
                          name="city"
                          value={formData.city}
                          onChange={handleFormData}
                          className="col-md-12"
                        />
                      </div>

                      <div className="col-md-6 p-3">
                        <FormControl variant="standard" className="col-12">
                          <InputLabel id="demo-simple-select-label">
                            Course Applied For
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={formData.applied_course}
                            label="Select "
                            name="applied_course"
                            onChange={handleFormData}
                          >
                            {courses &&
                              courses.filter((e)=> e.effected_to == 'present').map((c) => (
                                // <>
                                //   {c.effected_to === "present" && (
                                    <MenuItem value={c.courseName}>
                                      {c.courseName}
                                    </MenuItem>
                                //   )}
                                // </>
                              ))}
                          </Select>
                        </FormControl>
                      </div>

                      <div className="col-md-12 p-5 text-center">
                        <Button variant="contained" onClick={handleOpen}>
                          {" "}
                          Register{" "}
                        </Button>
                      </div>

                      <FormDialog
                        form={<FileUpload />}
                        open={open}
                        handleClose={handleClose}
                      />
                    </div>
                  </Paper>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Register;
